/**
 * Reads the CSP nonce from the <meta property="csp-nonce"> tag in index.html, matching
 * the 'nonce-...' value in the style-src CSP directive so Emotion's cache can tag its
 * injected <style> tags with it (JSS reads this same meta tag on its own).
 * @return {string | undefined} the configured nonce, or undefined if the meta tag is missing
 */
export default function getCspNonce(): string | undefined {
  return document.querySelector('meta[property="csp-nonce"]')?.getAttribute('content') ?? undefined;
}
